/**
 * A list of names in a sentence — "E2E Corp and Tonnie Talent".
 *
 * `Intl.ListFormat` would do this, but Hermes (the phone) has none, and a list
 * joined differently on the web and on the phone is two answers to one
 * question. So the pattern is a translation (`common.list.two`) both read: the
 * last name joins the rest with the locale's own "and", the rest by commas.
 */
import type { TFunction } from 'i18next';

export function formatList(items: readonly string[], t: TFunction): string {
  if (items.length <= 1) return items[0] ?? '';
  return t('common.list.two', {
    first: items.slice(0, -1).join(', '),
    second: items[items.length - 1],
  });
}
